import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import {
  ContractIdentifierWithApi,
  DetailsTableRow,
  HistoryLink,
  TileSide,
  TileSideHeader,
} from '../../../components';
import Skeleton from 'react-loading-skeleton';
import {
  BodyText,
  HashLength,
  Table,
  TableDataHeader,
  TableFooterContainer,
} from '@block-explorer/ui';
import { FlexColumn, TableData, TableRow } from '@make-software/cspr-design';
import { useGetContractPackages } from '../../../hooks/event-store-hooks';
import { buildRouterPath } from '../../../router/utils';
import { CONTRACT_LIST_PATH } from '../../../router/paths';
import styled from 'styled-components';
import { filterSystemContracts } from '../utils';

const StyledTableRowHead = styled(TableRow)(() => ({
  height: '54px',
}));

const StyledTableRowBody = styled(TableRow)(() => ({
  height: '72px',
}));

export const TrendingContracts = () => {
  const { t } = useTranslation();

  const { data: contracts, loading } = useGetContractPackages({
    includes:
      'account_info,centralized_account_info,activity_num(7,true),cspr_name',
  });

  const filteredSystemContracts = filterSystemContracts(contracts);

  if (loading) {
    return (
      <TileSide>
        <FlexColumn gap={24}>
          <TileSideHeader title={<Trans t={t}>Trending Apps</Trans>} />
          <Table
            renderData={() => (
              <DetailsTableRow>
                <TableData>
                  <FlexColumn gap={16}>
                    <Skeleton count={1} height={'108px'} width={'100%'} />
                    <Skeleton count={1} height={'108px'} width={'100%'} />
                    <Skeleton count={1} height={'80px'} width={'100%'} />
                    <Skeleton count={1} height={'60px'} width={'100%'} />
                    <Skeleton count={1} height={'60px'} width={'100%'} />
                    <Skeleton count={1} height={'60px'} width={'100%'} />
                  </FlexColumn>
                </TableData>
              </DetailsTableRow>
            )}
          />
        </FlexColumn>
      </TileSide>
    );
  }

  return (
    <TileSide>
      <FlexColumn gap={24}>
        <TileSideHeader title={<Trans t={t}>Trending Apps</Trans>} />
        <Table
          renderDataHeaders={() => (
            <StyledTableRowHead>
              <TableDataHeader>
                <Trans t={t}>contract</Trans>
              </TableDataHeader>
              <TableDataHeader align={'right'}>
                <Trans t={t}>7d activity</Trans>
              </TableDataHeader>
            </StyledTableRowHead>
          )}
          renderData={() =>
            filteredSystemContracts?.map((contract, index) => (
              <StyledTableRowBody key={contract.contract_package_hash}>
                <TableData>
                  <ContractIdentifierWithApi
                    contractPackage={contract}
                    hash={contract.contract_package_hash}
                    hashLength={HashLength.TINY}
                    loading={loading}
                    withName
                  />
                </TableData>
                <TableData align={'right'}>
                  <BodyText size={3} noWrap>
                    {contract.activity_number}
                  </BodyText>
                </TableData>
              </StyledTableRowBody>
            ))
          }
          renderFooter={() => (
            <TableFooterContainer hideBorder>
              <BodyText size={3} scale={'sm'}>
                <HistoryLink
                  ariaDescription={'Link to contracts list'}
                  href={buildRouterPath(
                    CONTRACT_LIST_PATH,
                    undefined,
                    undefined
                  )}
                >
                  {t('View all Contracts')}
                </HistoryLink>
              </BodyText>
            </TableFooterContainer>
          )}
        />
      </FlexColumn>
    </TileSide>
  );
};
